<!-- 最近发货的物流 -->
<template>
  <div class="recent" v-if="deliver.oneGoodsName">
    <div class="title">
      <span class="staus">最近发货</span>
      <p class="all" @click="toAllLogistics">
        <b>全部发货物流</b>
        <van-icon name="arrow" />
      </p>
    </div>
    <div class="express">
      <div class="express-name">
        <h1>
          <span class="status">{{ deliveryStatus[Number(deliver.deliveryStatus)] }}</span>
          <span class="name">{{ deliver.expressName }}</span
          ><b>{{ deliver.expressNo }}</b>
        </h1>
        <button @click="openLogistics">查看物流</button>
      </div>
      <h2 class="book">
        {{ deliver.oneGoodsName
        }}{{ deliver.goodsTotal > 1 ? `等${deliver.goodsTotal}本讲义` : '' }}
      </h2>
    </div>
    <LogisticsDetail :showDetail="showDetail" :deliverData="deliver" @close="close" />
  </div>
</template>

<script>
import LogisticsDetail from './logisticsDetail.vue';

export default {
  data() {
    return {
      deliveryStatus: {
        0: '揽件中',
        1: '在途中',
        2: '派件中',
        3: '已签收',
        4: '派送失败',
        5: '疑难件',
        6: '退件签收',
      },
      showDetail: false,
    };
  },
  props: {
    deliver: {
      type: Object,
      default: () => {},
    },
  },
  components: { LogisticsDetail },

  computed: {},

  mounted() {},

  created() {},

  methods: {
    openLogistics() {
      this.$emit('setDisabled', true);
      this.showDetail = true;
    },
    close() {
      this.$emit('setDisabled', false);
      this.showDetail = false;
    },
    toAllLogistics() {
      this.$router.push({
        path: 'logistics',
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.recent {
  padding: 40px;
}
.title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0 40px 0;
  .staus {
    color: #333;
    font-weight: 800;
    font-size: 36px;
  }
  .all {
    display: flex;
    align-items: center;
    b {
      color: #787878;
      font-weight: 400;
      font-size: 28px;
    }
    ::v-deep .van-icon.van-icon-arrow {
      color: #cfcfcf;
      font-size: 16px;
    }
  }
}
.express {
  width: 670px;
  min-height: 164px;
  margin: 0 auto;
  padding: 36px 0 36px 36px;
  background: #fff;
  border-right: 16px;
  .express-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 24px 0;
    h1 {
      display: flex;
      align-items: center;
      .status {
        height: 36px;
        margin: 0 10px 0 0;
        padding: 2px 10px;
        font-size: 24px;
        color: #fff;
        font-weight: 400;
        line-height: 34px;
        background: #ff6c02;
        border-radius: 8px;
      }
      .name {
        padding: 0 20px 0 0;
        color: #333;
        font-weight: 800;
        font-size: 28px;
      }
      b {
        display: inline-block;
        width: 170px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        color: #787878;
        font-weight: 400;
        font-size: 28px;
      }
    }
    button {
      height: 40px;

      padding: 0 12px;
      color: #fff;
      font-size: 22px;
      line-height: 40px;
      text-align: center;
      background: #ff6c02;
      border: none;
      border-radius: 37px 0 0 37px;
    }
  }
  .book {
    padding: 0 36px 0 0;
    color: #787878;
    font-size: 28px;
    line-height: 40px;
  }
}
</style>
